module.exports = __webpack_public_path__ + "img/foot-link3.1a92e03b.png";